import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';
import { KlenicoMeService } from '../me.service';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../shared/base.service';
import { AuthService } from '../../core/auth.service';

@Injectable()
export class MeSelfReportService extends KlenicoMeService{
    srStep = 0;
    patientId = 0;
    token = '';
    COMPONENT = '';
    constructor(
        public secureApi: SecureApi,
        public appService: AppService,
        public translateService: TranslateService,
        public baseService: BaseService,
        public http : HttpClient,
        public authService: AuthService,
        @Inject('storyBlokToken') public storyBlokToken: string,
        @Inject('storyBlokAPI') public storyBlokAPI: string,
    ) {
        super(secureApi, appService, translateService, http, storyBlokToken, storyBlokAPI);
    }

    updateProfile(data) {
        return this.secureApi.post('b2c-patients/update-profile/' + this.patientId, data, false);
    }

    updatePatientContext(data) {
        return this.secureApi.post('b2c-patients/update-context', data, false);
    }

    updateSRStep(step) {
        let data = {
            'me_step' : step
        };
        return this.secureApi.post('b2c-patients/update-me-questionnaire-step', data, false);
    }

    updatePatientStep(step) {
        let data = {
            'me_step' : step
        };
        return this.secureApi.post('b2c-patients/update-me-patient-step', data, false);
    }

    archiveSR() {
        let patientId = this.authService.patientId;
        return this.secureApi.get('b2c-patients/archive-patient-sr/' + patientId);
    }

    createSR() {
        let patientId = this.authService.patientId;
        const model = {
            patient_id: patientId,
            questionnaire_type_id: 'se_di',
            answer_method: 'local',
            is_pdf: 0,
            is_repeated: 0,
            is_b2c: 1
        };
        return this.baseService.submit('patient/save-questionnaire', patientId, model);
    }
}
